export default "__VITE_ASSET__3ShmYX4U__"